/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkerPartialUpdate
 */
export interface MarkerPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof MarkerPartialUpdate
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof MarkerPartialUpdate
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof MarkerPartialUpdate
     */
    tIn?: number;
    /**
     * 
     * @type {number}
     * @memberof MarkerPartialUpdate
     */
    tOut?: number;
    /**
     * 
     * @type {number}
     * @memberof MarkerPartialUpdate
     */
    asset?: number;
}

export function MarkerPartialUpdateFromJSON(json: any): MarkerPartialUpdate {
    return MarkerPartialUpdateFromJSONTyped(json, false);
}

export function MarkerPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkerPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'tIn': !exists(json, 't_in') ? undefined : json['t_in'],
        'tOut': !exists(json, 't_out') ? undefined : json['t_out'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
    };
}

export function MarkerPartialUpdateToJSON(value?: MarkerPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'text': value.text,
        't_in': value.tIn,
        't_out': value.tOut,
        'asset': value.asset,
    };
}


